const getTitleContainerId = (id: string) => `group-title-container-${id}`;

export { getTitleContainerId };
